import React, { useEffect, useState } from 'react';
import { RouteProps, useNavigate } from 'react-router-dom';
import {
  ApplicationPaths,
  QueryParameterNames
} from './ApiAuthorizationConstants';
import { useAuth } from '../../auth/AuthContext';

interface AuthorizeRouteProps extends RouteProps {
  component: React.ComponentType;
}

export const AuthorizeRoute = (props: AuthorizeRouteProps) => {
  const [ready, setReady] = useState(false);
  const { user, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const { component: Component } = props;
  const redirectUrl = `${ApplicationPaths.Login}?${
    QueryParameterNames.ReturnUrl
  }=${encodeURI(globalThis.location.href)}`;

  useEffect(() => {
    if (isLoading) return;

    // If the user object is expired but we are still authenticated in the store,
    // do NOT redirect immediately: automaticSilentRenew may be completing in the
    // background. Only force login when there is definitively no user at all.
    if (!isAuthenticated && (!user || user.expired)) {
      navigate(redirectUrl, { replace: true });
      return;
    }

    if (!user?.expired) {
      setReady(true);
    }
  }, [isLoading, isAuthenticated, user, navigate, redirectUrl]);

  if (!ready) {
    return <div></div>;
  }

  return isAuthenticated && !user?.expired ? <Component {...props} /> : null;
};
